import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ArrowRight } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { useState, useRef, useEffect } from 'react'
import { FilePathField } from '../../Fields/FilePathField'
import { useFormikContext } from 'formik'
import { useAutocomplete } from 'components/Wizards/DesktopWizards/useAutocomplete'
import { useWizardSchema } from 'components/Wizards/Wizard/WizardContext'
import { MultiStepSchema, WizardType } from 'components/Wizards/schemas/Types'
import { PollFieldsetCompletion } from 'components/PollFieldsetCompletion/PollFieldsetCompletion'
import { BlogLengthField } from '../../Fields/BlogLengthField'

export const ContentSettings = multiStep(({ schema, submit, getSchemaField }) => {
  const { meta } = schema.describe()

  const [isLoading, setIsLoading] = useState(false)
  const lengthField = getSchemaField('blog_length')
  const { values, setFieldValue, setStatus, initialStatus } = useFormikContext<any>()
  const hasInitialized = useRef(false)
  const wizardSchema = useWizardSchema() as MultiStepSchema<WizardType>

  const { handleGenerate, handleComplete, data } = useAutocomplete({
    schema: wizardSchema,
    values,
    setFieldValue,
    setStatus,
    initialStatus,
    onLoadingChange: setIsLoading,
  })

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true
      if (values.topic && !values.filename) {
        handleGenerate({ fields: ['filename'] })
      }
    }
  }, [values.topic, values.filename, handleGenerate])

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      await submit()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <PollFieldsetCompletion fieldsetCompletionId={data?.fieldset_completion?.id} onComplete={handleComplete} />
      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>

        {lengthField && <BlogLengthField blogLengthField={lengthField} />}
        <FilePathField isLoading={isLoading} />
      </MobileWizard.Content>

      <MobileWizard.ButtonFooter>
        <Button
          size="lg"
          variant="primary"
          endIcon={ArrowRight}
          fullWidth
          onPress={handleSubmit}
          isDisabled={isLoading}
        >
          {meta.submitLabel}
        </Button>
      </MobileWizard.ButtonFooter>
    </>
  )
})
